import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';

export const useBanks = () => {
    const [banks, setBanks] = useState([]);
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });

    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const fetchBanks = async (url) => {
        try {
            const response = await Fetch.post(
                config.endpoints.backend + 'portal/getallbankaccounts',
                {
                    filter: {
                        friendly_url
                    }
                }
            );


            if (Array.isArray(response)) {
                const banksValues = response.map((bank) => {
                    return {
                        value: bank.id,
                        label: bank.accountid
                    };
                });

                setBanks(banksValues);
            }
        } catch (error) {
            setBanks([]);
        }
    };

    useEffect(() => {
        fetchBanks();
    }, [friendly_url]);

    return banks;
};
